import React from 'react'
import SEO from '../../seo/SEO'
import InuquiryBanner from './InuquiryBanner/InuquiryBanner'

const INQUIRENOW = () => {
  return (
    <>
      <SEO />
    <div>
      <InuquiryBanner/>
    </div>
    </>
  )
}

export default INQUIRENOW
